<template>
  <div class="footer mainFooter">
    <div class="row">
      <div class="col-6 text-right foot_left pr-10">
        <div class="responsive-text">หลักสูตรด้านสิทธิเด็ก และ การคุ้มครองเด็กออนไลน์</div>
        <div class="responsive-text">โดยความร่วมมือของ</div>
      </div>
      <div class="col-6 text-left foot_right pl-10">
        <img
          src="/logo-1.png" 
          width="auto"
          alt="E-learning"
          class="logo-img mr-4"
        />
        <img src="/logo-2.png" class="logo-img" width="auto" alt="E-learning" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "mainFooter",
  data() {
    return {};
  },
};
</script>
<style lang="scss">
@import "/src/assets/scss/style.scss";
.mainFooter {
  height: 100px;
  background: $footer-color;
  text-align: center;
}
// .foot_left,.foot_right{
//   display: flex;
//   flex-wrap: nowrap;
//   flex-direction: column;
//   justify-content: space-around;
// }
.mainFooter > .row {
  height: 80px;
  padding-top: 20px;
}
.foot_left {
  color: white;
  border-right: 2px solid white;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
}
.foot_right {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.logo-img {
    height: 30px;
  }
.responsive-text{
  font-size: 12px;
}

  @media (min-width: 768px) {
    .logo-img {
      height: 60px;
    }
    .responsive-text{
      font-size: 16px;
    }
  }
</style>
